export default function waitReject(duration, reason = 'TIMED_OUT') {
    return new Promise((_, reject) => {
        setTimeout(() => reject(reason), duration);
    });
}
